var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F39200",
    d: "M9.272 6.722c0 2.486-1.963 4.501-4.386 4.501S.5 9.208.5 6.722 2.464 2.22 4.886 2.22v4.502zM6.212.644c2.539 0 4.596 2.112 4.596 4.717z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39200",
    d: "M6.212.644v4.717h4.596"
  })));
};
export default SvgAnalytics;